<div [id]="'dummyContainer-' + componentId" appClick #dummyContainerRef class="dummy-container" style="pointer-events: none;"
  (click)="onDummyContainerClick($event)"></div>

<div [hidden]="isMinimized" [class.hidden-dialog]="isMinimized" [class.is-maximized]="isMaximized" [class.isdialog-window--active]="isWindowActive" [class.isdialog-window--pinned]="isPinned"
  [class.is-minimizing]="isMinimizing" [class.is-restoring]="isRestoring" [class.is-opening]="isOpening"
  [class.is-auto-width]="dialogWidth === null" class="dialog" id="{{componentId}}"
  style="pointer-events: auto;" [style.height.px]="dialogHeight ?? null" [style.width.px]="dialogWidth ?? null" cdkDrag [cdkDragDisabled]="isPictureInPicture || isResizing || isManualSnappedDrag || isSnapped"
  [cdkDragBoundary]="dummyContainerRef" [cdkDragFreeDragPosition]="dragPosition" (cdkDragStarted)="onDragStart($event)"
  (cdkDragMoved)="onDragMoved($event)" (cdkDragEnded)="onDragEnd($event)" (click)="onDialogClicked()">

  <div class="window-bar" style="z-index: 999999" id="{{windowBarId}}" (pointerdown)="onSnappedWindowPointerDown($event)" (contextmenu)="onBarContextMenu($event)" (dblclick)="!isPictureInPicture && maximizeDialog()" cdkDragHandle>

    <div class="window-title w-100">
      <div class="m-0 d-flex" [hidden]="!data.title" (dblclick)="changeTitle($event)">
        <i class="fas me-1 my-auto fa-fw fa-fh title-icon" [ngClass]="'fa-fw fa-' + data.iconTitle"
          *ngIf="data.iconTitle && data.iconTitleBefore"></i>

        <span class="title-wrapper-window" *ngIf="!editTitle">
          {{ data.title }}
        </span>

        <a>
          <i class="fas ms-2 my-auto fa-fw fa-fh pointer toolbar-buttons fa-fw fa-pencil" [hidden]="editTitle"
            (click)="changeTitle()"></i>
        </a>

        <input *ngIf="!isMinimized" class="title-change-input" [value]="data.title" [hidden]="!editTitle"
          id="{{tabTitleId}}input" [cdkTrapFocus]="editTitle" [cdkTrapFocusAutoCapture]="editTitle"
          (keyup.enter)="saveTitleChange()" (dblclick)="$event.stopPropagation()" (blur)="saveTitleChange()"
          (mousedown)="$event.stopPropagation()">
      </div>
    </div>

    <div class="window-controls" (pointerdown)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
      <!-- Opções secundárias. O menu é sempre o primeiro controlo. -->
      <div class="isdialog-window-utilities">
        <a *ngIf="!isPictureInPicture" [matMenuTriggerFor]="windowActionsMenu" #windowActionsTrigger="matMenuTrigger"
           title="Mais opções da janela" aria-label="Mais opções">
          <i class="fa-solid fa-ellipsis toolbar-buttons"></i>
        </a>
        <a *ngIf="isPictureInPictureSupported || isPictureInPicture"
           (click)="togglePictureInPicture($event)"
           [attr.title]="isPictureInPicture ? 'Voltar ao CRM' : 'Destacar janela para outro monitor'">
          <i class="fa-solid toolbar-buttons"
             [ngClass]="isPictureInPicture ? 'fa-arrow-right-to-bracket' : 'fa-arrow-up-right-from-square'"></i>
        </a>
        <a [matMenuTriggerFor]="opacityMenu" title="Opacidade">
          <i class="fa-solid fa-glasses toolbar-buttons"></i>
        </a>
        <a *ngIf="!isPictureInPicture" [matMenuTriggerFor]="windowSnapMenu" title="Organizar janela">
          <i class="fa-solid fa-magnifying-glass toolbar-buttons"></i>
        </a>
        <button *ngIf="!isPictureInPicture" type="button"
                class="isdialog-pin-button" [class.isdialog-pin-button--active]="isPinned"
                [attr.title]="isPinned ? 'Desafixar janela' : 'Fixar janela'"
                [attr.aria-label]="isPinned ? 'Desafixar janela' : 'Fixar janela'"
                [attr.aria-pressed]="isPinned"
                (click)="togglePin($event)">
          <i class="fa-solid fa-thumbtack toolbar-buttons" aria-hidden="true"></i>
        </button>
      </div>

      <!-- Ações principais separadas das opções secundárias. -->
      <div class="isdialog-window-system-controls">
        <a *ngIf="!isPictureInPicture" class="minimize-button" title="Minimizar janela"
           (click)="$event.stopPropagation(); onMinimize()">
          <i class="fa-solid fa-minus toolbar-buttons"></i>
        </a>
        <a *ngIf="!isPictureInPicture" (click)="maximizeDialog()"
           [attr.title]="isMaximized ? 'Restaurar janela' : 'Maximizar janela'">
          <i class="fa-solid toolbar-buttons"
             [ngClass]="{'fa-window-maximize': !isMaximized, 'fa-window-restore': isMaximized}"></i>
        </a>
        <a class="close-button" title="Fechar janela" (click)="closeDialog()">
          <i class="fa-solid fa-xmark toolbar-buttons close-button-icon"></i>
        </a>
      </div>
    </div>
  </div>


  <div *ngIf="pictureInPictureError" class="pip-error" role="alert">
    {{ pictureInPictureError }}
    <a (click)="pictureInPictureError = null" title="Fechar aviso">×</a>
  </div>

  <div *ngFor="let edge of resizeHandles" class="isdialog-resize-handle"
       [ngClass]="'isdialog-resize-handle--' + edge" [hidden]="!canResize"
       appResize [resizeEdge]="edge" [resizeRect]="currentGeometry"
       [resizeDisabled]="!canResize" [resizeMinWidth]="minResizeWidth"
       [resizeMinHeight]="minResizeHeight"
       (resizeStart)="onResizeStart()"
       (resizeRectChange)="onResizeRectChange($event)" (resizeEnd)="onResizeEnd()"></div>

  <div class="dialog-body" [class.isdialog-bootstrap-grid-container]="bootstrapGridEnabled" [ngStyle]="data.dialogBodyStyle">
    <ng-template appInsertion></ng-template>
    <ngx-spinner [name]="componentId" bdColor="rgba(51, 51, 51, 0.8)" size="large"
      color="var(--kt-input-group-addon-color)" type="ball-pulse" [template]="spinnerTemplate"
      [fullScreen]="false"></ngx-spinner>
  </div>

</div>

<!-- A taskbar global é criada automaticamente pelo ISDialogService. -->

<mat-menu #opacityMenu>
  <div class="slider-container" cdkMenu>
    <mat-slider [color]="'success'" min="1" max="85" step="1" percentage="85">
      <input matSliderThumb [value]="currentOpacity" (valueChange)="onOpacityChange($event)">
    </mat-slider>
  </div>
</mat-menu>


<mat-menu #windowSnapMenu>
  <div class="snap-container" style="margin-bottom: 5px;">
    <div class="snap-row" style="margin-bottom: 2px;">
      <div class="snap-item-left-top" (click)="moveDialogToTopLeft()"></div>
      <div class="snap-item-right-top" (click)="moveDialogToTopRight()"></div>
    </div>
    <div class="snap-row">
      <div class="snap-item-left-bottom" (click)="moveDialogToBottomLeft()"></div>
      <div class="snap-item-right-bottom" (click)="moveDialogToBottomRight()"></div>
    </div>
  </div>
  <div class="snap-container">
    <div class="snap-row">
      <div class="snap-item-left" (click)="moveDialogToLeft()"></div>
      <div class="snap-item-right" (click)="moveDialogToRight()"></div>
    </div>
  </div>
</mat-menu>
<mat-menu #windowActionsMenu="matMenu" class="isdialog-actions-menu">
  <button mat-menu-item *ngIf="!isPictureInPicture" (click)="centerDialog()"><i class="fa-solid fa-crosshairs me-2"></i>Centrar janela</button>
  <button mat-menu-item *ngIf="!isPictureInPicture" (click)="resetDialogSize()"><i class="fa-solid fa-compress me-2"></i>Tamanho inicial</button>
</mat-menu>
